import Swal from "sweetalert2";
import {responses} from "@/services/responses";
import axios from 'axios'
import {errorHandler} from "@/services/errorHandler";
import Vue from 'vue'
import {utils} from "@/services/utils";
import copy from 'copy-to-clipboard';

window.axios = axios;
window.copy = copy;
window.errorHandler = errorHandler;
window.responses = responses;
window.Swal = Swal;

Vue.prototype.$utils = utils;
window.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});


window.ticketApi = `https://lna.abc.co.zm/TicketApp/`
// window.ticketApi = `http://192.168.1.244:8181/TicketApp/`

window.synergyApi = 'https://lna.abc.co.zm/SynergyApi/'
// window.synergyApi = 'http://192.168.1.244:8181/SynergyApi/'


window.localApiLogs ="https://overflow.abc.co.zm:8443/logger/api/v1/logs"
// window.localApiLogs ="http://192.168.1.244:8181/logger/api/v1/logs"

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}
window.Toast = Toast;